import React from 'react';
import StatisticItem from '../shared/StatisticItem';

const StatsGrid = ({ stats }) => {
  return (
    <div className="quick-stats">
      {stats.map((stat, index) => (
        <StatisticItem 
          key={index}
          label={stat.label}
          value={stat.value}
        />
      ))}
    </div>
  );
};

export default StatsGrid;